import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { defaultConfig, sizes, isFrench } from '../config'
import { parseInteger } from '../helpers'
import Pagination from './Pagination'

export default ({ isGroupedCollection }) => {
    const { query, response } = useAppState();
    const { updateSearch } = useActions();

    const from = parseInteger(query.products?.from);
    const size = parseInteger(response.products.size);
    const total = parseInteger(response.products.total);
    const to = from + size;

    const sizeOptions = [...sizes]
        .reverse()
        .filter((value) => value + defaultConfig.serpSize < total)

    return ((!isGroupedCollection) && (
        <div class="ns-bot-toolbar flex flex-col">
            {(response?.products?.total > defaultConfig.serpSize) && 
                <Pagination />
            }
            <div class="ns-products-showing hidden text-center">
                {isFrench
                    ?   `Vous avez vu ${(from === 0) ? 1 : from} - ${(total < to) ? total : to} produits sur ${total}`
                    :   `Showing ${(from === 0) ? 1 : from} - ${(total < to) ? total : to} of ${total} items`
                }
            </div>
        </div>
    ))
}
